module.exports = __webpack_public_path__ + "static/DY4-4ffb283ee5c672f2c78329aa16515f01.jpg";